import HomeFeaturedEditionForm from './HomeFeaturedEditionForm';

export default HomeFeaturedEditionForm;
